import React, { useState } from "react";
import "./AccountPage.css";
import {
  PageSurface,
  PageWrapper,
} from "../../../../../components/layout/container/Container";
import { PageHeader } from "../../../../../components/layout/header/Header";
import { PageHeading } from "../../../../../components/common/heading/Heading";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../hooks/useProfile";
import {
  PersonalDetailsForm,
  SecurityForm,
  DangerZoneForm,
} from "../components/AccountForm";
import StatusAlert from "../../../../../components/alerts/StatusAlert";

const MemberAccountPage = () => {
  document.title = "Settings | Account";
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const {
    profile,
    loading,
    error,
    setProfile,
    handleUpdatePersonalDetails,
    handlePasswordUpdate,
    handleDeleteAccount,
  } = useProfile();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <PageSurface>
      <PageWrapper size="lg">
        <PageHeader>
          <PageHeading
            title={"Account Details"}
            subTitle={"Manage your personal information and security."}
          />
        </PageHeader>

        {error.message && <StatusAlert status={error} />}

        <PersonalDetailsForm
          profile={profile}
          onChange={handleInputChange}
          onSave={handleUpdatePersonalDetails}
          loading={loading}
        />

        <SecurityForm
          profile={profile}
          password={newPassword}
          setPassword={setNewPassword}
          onSave={() => handlePasswordUpdate(newPassword)}
          loading={loading}
        />

        <DangerZoneForm onDelete={() => handleDeleteAccount(navigate)} />
      </PageWrapper>
    </PageSurface>
  );
};

export default MemberAccountPage;
